import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M99.35 26.1599C96.93 27.3699 92.52 27.7 92.52 27.7C96.92 24.73 99.13 17.02 99.13 17.02L82.62 1.93994H19.72L3.21002 17.02C3.21002 17.02 5.41001 24.73 9.82001 27.7C9.82001 27.7 5.41999 27.3699 2.98999 26.1599C2.98999 26.1599 6.94997 34.0899 14.22 32.8799C14.22 32.8799 11.69 36.2899 7.60999 37.1699C7.60999 37.1699 14.55 42.34 21.37 39.7C21.37 39.7 19.5 43 16.97 45.7599C16.97 45.7599 22.25 48.6199 26.44 46.7499L25.01 49.1699C25.01 49.1699 28.86 49.0599 31.4 47.7399L28.98 52.7999C28.98 52.7999 37.46 56.7599 47.59 53.3499H54.79C64.92 56.7599 73.4 52.7999 73.4 52.7999L70.98 47.7399C73.51 49.0599 77.37 49.1699 77.37 49.1699L75.94 46.7499C80.12 48.6199 85.41 45.7599 85.41 45.7599C82.88 43.0099 81.01 39.7 81.01 39.7C87.84 42.34 94.77 37.1699 94.77 37.1699C90.7 36.2899 88.16 32.8799 88.16 32.8799C95.39 34.0899 99.35 26.1599 99.35 26.1599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
